import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import IconArrow from './icon_arrow.svg';
import s from './index.module.scss';

export const ReadMoreLess = ({ text = '', rows = 5, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  const { t } = useTranslation('brands');

  useEffect(() => {
    if (textRef.current) {
      const computedStyle = window.getComputedStyle(textRef.current);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const maxHeight = lineHeight * rows;
      if (textRef.current.scrollHeight > maxHeight) {
        setIsTruncated(true);
      } else {
        setIsTruncated(false);
      }
    }
  }, [rows, text]);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={className}>
      <div
        ref={textRef}
        className={s.text}
        style={{
          maxHeight: isExpanded ? 'none' : `${rows * 1.2}em`,
          WebkitLineClamp: isExpanded ? 'none' : rows,
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
        }}
      >
        {text}
      </div>
      {isTruncated && (
        <button
          onClick={toggleReadMore}
          className={classnames(s.button, isExpanded && s.button_active)}
        >
          {isExpanded
            ? t('read_more_less.read_less')
            : t('read_more_less.read_more')}
          <img
            src={IconArrow}
            alt={t('read_more_less.arrow_alt')}
            width={20}
            height={20}
          />
        </button>
      )}
    </div>
  );
};
